<template>
  <div class="detail-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <div class="card-content" v-loading="loading">
            <div class="detail-title">【{{noticeData.typename}}】{{noticeTitle}}</div>
            <div class="detail-info">
              <span><svg-icon icon-class="group"/>{{noticeData.groupname}}-{{noticeData.deptname}}</span>
              <span style="margin: 0 20px;"><i class="el-icon-time" style="margin-right: 4px"/>{{noticeData.time}}</span>
              <el-popover
                placement="bottom-start"
                trigger="hover">
                <div class="user-list">
                  <div class="user-item" v-for="u in noticeUser">
                    <el-avatar :size="50" fit="cover" :src="u.photo!==null&&u.photo!==''?u.photo:u.sex==='男'?men:women"></el-avatar>
                    <div class="name">{{u.username}}</div>
                  </div>
                </div>
                <span slot="reference" style="color:#409EFF;cursor: pointer;"><i class="el-icon-view" style="margin-right: 4px"/>{{viewsNum}}人已读</span>
              </el-popover>
            </div>
            <div style="background: #f6f8fa;margin-top: 20px;padding: 20px" v-html="noticeData.content"></div>
            <div style="padding:20px">
              <div class="detail-file-title" v-if="noticeFiles.length>0">
                附件列表 :
              </div>
              <div class="detail-file" v-if="noticeFiles.length>0">
                <div class="file-box" @click="downLoad(file)" v-for="file in noticeFiles" :title="`${file.filename}.${file.filetype}`">
                  <div class="file-icon">
                    <i class="el-icon-document"/>
                  </div>
                  <div class="file-name">
                    <span>{{file.filename}}.{{file.filetype}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getNoticeDetail } from '@/api/home'
import { getFileInfo} from '@/api/pub'
import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'

export default {
  name: 'notice_detail',
  data(){
    return{
      men: men,
      women: women,
      nid: '',
      noticeData: [],
      noticeFiles: [],
      noticeTitle: '',
      noticeUser: [],
      fileNum: 0,
      viewsNum: 0,
      loading: false
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.nid = this.$route.params && this.$route.params.nid
    this.getNoticeDetail()
  },
  computed: {
    user: getUser
  },
  methods:{
    getNoticeDetail(){
      this.loading = true
      const _this = this
      let _userid = 0
      if (_this.user.rank === 0) {
        _userid = _this.user.dUserid
      } else {
        _userid = _this.user.userid
      }
      const data = {
        noticeId: _this.nid,
        userId: _userid,
        role: _this.user.rank
      }
      getNoticeDetail(data).then(response=>{
        _this.noticeData = response.data
        _this.noticeTitle = response.data.title
        _this.noticeFiles = response.data.noticeAnnexList
        _this.noticeUser = response.data.nrlst
        _this.viewsNum = response.data.nrlst.length
        _this.setTagsViewTitle()
        this.loading = false
      })
    },
    setTagsViewTitle() {
      const route = Object.assign({}, this.tempRoute, { title: `${this.noticeTitle}` })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    },
    downLoad(file) {
      getFileInfo({ fileid: file.fileid }).then(response => {
        /* this.$message({
          message: '文件已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .detail-container {
    .tcf-row{
      .card{
        .card-body{
          .card-content{
            .detail-title{
              font-size: 25px;
            }
            .detail-info{
              margin-top: 20px;
              padding-left: 10px;
            }
            .detail-file{
              width: 100%;
              margin-bottom: .6rem;
              position: relative;
              box-sizing: border-box;
              .file-box{
                width: 120px;
                height: 127px;
                float: left;
                margin: 4px 0 0 6px;
                text-align: center;
                position: relative;
                border-radius: 5px;
                font-size: 12px;
                .file-icon{
                  font-size: 55px;
                  position: relative;
                  margin: 9px auto 0;
                  width: 74px;
                  height: 74px;
                  overflow: hidden;
                  cursor: pointer;
                }
                .file-name{
                  display: block;
                  margin: 6px 5px 5px;
                  span{
                    cursor: pointer;
                    color: #424e67;
                    text-decoration: none;
                  }
                }
              }
            }
            .detail-file-title{
              font-size: 13px;
            }
          }
        }
      }
    }
  }
  .user-list{
    max-width: 440px;
    position: relative;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;
    .user-item{
      width: 50px;
      height: 80px;
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
      .name{
        width: 100%;
        position: relative;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
